import { z } from 'zod';

import type { SetupShippingRateDraft } from '@/components/setup/experience/lib/setupShippingRateTypes';

export interface SetupShippingRateSchemaMessages {
  nameRequired: string;
  priceRequired: string;
  priceInvalid: string;
  countriesRequired: string;
  ratesMin: string;
}

export function createSetupShippingRatesSchema(messages: SetupShippingRateSchemaMessages) {
  const rateSchema = z
    .object({
      id: z.string().optional(),
      shippingRateName: z.string().trim().min(1, messages.nameRequired),
      icon: z.string(),
      isFree: z.boolean(),
      priceMajor: z.string(),
      allCountries: z.boolean(),
      countryCodes: z.array(z.string()),
      // Not editable here — validated only so the persisted value survives the round-trip (#TAG-1779).
      isPickupPoint: z.boolean(),
    })
    .superRefine((rate, ctx) => {
      if (!rate.allCountries && rate.countryCodes.length === 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: messages.countriesRequired,
          path: ['countryCodes'],
        });
      }

      if (rate.isFree) return;

      const price = rate.priceMajor.trim();
      if (!price) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, message: messages.priceRequired, path: ['priceMajor'] });
        return;
      }

      const parsed = Number.parseFloat(price.replace(',', '.'));
      if (!Number.isFinite(parsed) || parsed <= 0) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, message: messages.priceInvalid, path: ['priceMajor'] });
      }
    });

  return z.object({
    rates: z.array(rateSchema).min(1, messages.ratesMin),
  });
}

export interface SetupShippingRatesFormValues {
  rates: SetupShippingRateDraft[];
}
